import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";

export const useGetSurveyQuestionnaire= () => {
     return useMutation({
        mutationFn: async ({body, config}) => {
            return axios.get(`${process.env.REACT_APP_API_URI}DownloadCasesFile?report=${body.report}&from=${body.fromDate}&to=${body.toDate}&role=${body.role}&msid=${body.msid}`, config).then((res) => res.data).catch(err => err);
          }, 
     })
  }
